// extracted by mini-css-extract-plugin
module.exports = {"goToPortalButton":"PastDueSubscription_goToPortalButton__3Cyoz","userCard":"PastDueSubscription_userCard__2F_6C"};